import React from "react";

const ImportResult = ({ result }) => {
  if (!result) return null;
  const { success, message, data } = result;
  const details = data != null && typeof data === "object" ? [
    ["Step", data.step],
    ["Error code", data.errorCode],
    ["Reference", data.reference],
    ["Transaction", data.transactionNumber],
    ["Lines", data.lineCount],
    ["Amount", data.amount],
  ].filter(([, value]) => value != null) : [];

  return (
    <div style={{ marginTop: 12, fontSize: 13, wordBreak: "break-word" }}>
      <div><strong>Import status:</strong> <span aria-label={success ? "Success" : "Error"}>{success ? "✅" : "❌"}</span></div>
      <div
        role={success ? "status" : "alert"}
        style={{
          marginTop: 8, padding: "8px 10px", border: `1px solid ${success ? "#16a34a" : "#dc2626"}`,
          borderRadius: 4, background: success ? "#f0fdf4" : "#fef2f2",
          color: success ? "#166534" : "#991b1b", whiteSpace: "pre-wrap", fontWeight: 600,
        }}
      >
        <strong>{success ? "Acomba response:" : "Acomba error:"}</strong>{" "}<span>{message}</span>
        {details.length > 0 && (
          <div style={{ marginTop: 6, display: "grid", gap: 2 }}>
            {details.map(([label, value]) => <span key={label}>{label}: {String(value)}</span>)}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImportResult;
